import QueryString from 'qs';

import { IUser } from '@src/models';
import request from 'src/services/request';
import { IJob, IClient, IApplicant } from 'src/models';

type IPostCvResponse = {
  status: string;
  filename: string;
  resume_url: string;
};

type IStat = {
  active_roles: number;
  active_jobs: number;
};

type IPostLogoResponse = {
  status: string;
  filename: string;
  logo_url: string;
};

type IPostClientsResponse = {
  status: string;
  entity: IClient;
};

interface IFilterParams {
  page?: number;
  per_page?: number;
  main_theme_id?: number;
  sub_theme_id?: number;
  experience?: string;
  industry?: string;
  location?: string;
  company_name?: string;
  status?: string;
}

export function getActiveRoles(qs) {
  return '/recruiters/active_roles' + qs;
}

interface IActiveJobsFilterParams extends IFilterParams {
  client_id?: number;
}

export function getActiveJobs(qs) {
  return '/recruiters/active_jobs' + qs;
}

export function getDashboardStats() {
  return '/recruiters/dashboard_stats';
}

export function getStatistics(userId: number) {
  return `/recruiters/${userId}/statistics`;
}

export function getLogs(params?: { action: string }) {
  return request.get(`/recruiters/dashboard_logs`, { params });
}

export function addCandidate(id) {
  return `/recruiters/jobs/${id}/add_candidate`;
}

export function uploadCv() {
  return '/recruiters/resume';
}

export function uploadCvDeprecated(payload: FormData) {
  return request.post<void, IPostCvResponse>('/recruiters/resume', payload);
}

export function parseCv(payload: { resume_url: string }) {
  return request.post<void, IPostCvResponse>('/anonymous_jobs/parse_resume', payload);
}

export const addToRole = `/recruiters/jobs/add_to_role`;

export function getJobApplicantsPreview(id, params: { page?: number; step_code?: string }) {
  return request.get<void, { entities: IApplicant[]; pagination: any }>(`/recruiters/jobs/${id}/applicants_list`, {
    params
  });
}

export function getJobSteps(id) {
  return request.get<void, any>(`/recruiters/jobs/${id}/steps`);
}

export function getJob(id) {
  return request.get<void, any>(`/recruiters/jobs/${id}`);
}

export const getClients = '/recruiters/clients';

export function uploadClientLogo(payload: FormData) {
  return request.post<void, IPostLogoResponse>('/recruiters/clients/logo', payload);
}

export const addClient = '/recruiters/clients';

export function getFilters(params: { type?: 'active_jobs' | 'active_roles' }) {
  return request.get(`/recruiters/jobs/filters`, { params });
}

export const updateRecruitersSettings = (payload: { password?: string; password_confirmation?: string }) =>
  request.put('/users/me/settings', payload);

export const updateUser = (payload: { user: IUser }) =>
  request.put<void, IUser>('/recruiters/settings/general', payload);
export const updateUserPreferences = (payload: { main_theme_ids: Array<number> }) =>
  request.post<void, IUser>('/recruiters/settings/preferences', payload);
export const getUserPreferences = () => request.get<void, IUser>('/recruiters/settings/preferences');
export const fetchClients = slug => {
  return request.get('/recruiters/clients/' + slug);
};
export const requestPostCustomQuestionAnswer = file => {
  return request.post('/recruiters/answer_file', file);
};
export const removeJob = jobId => {
  return '/recruiters/jobs/' + jobId;
};
export const postCustomQuestionAnswer = () => '/recruiters/answer_file';
